import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import { CompanyName, HOME_PAGE_URL } from '../../utils/Constants';
import NameHeaderComponent from '../general/NameHeaderComponent';
// Image (kept hidden on mobile per your classes)
import ImageHero from '../../assets/images/main/mistress-diva-index.webp';

function IndexPageMainContainer() {
  return (
    <header
      role='banner'
      aria-label='Homepage hero'
      className='grid w-full h-full text-colour1 dark:text-colour1 overflow-hidden'
    >
      <div className='grid h-full place-items-center px-4 py-8 overflow-hidden'>
        {/* Stack kept compact to avoid overflow */}
        <div className='grid gap-12 lg:gap-4 text-center lg:max-w-5xl lg:mx-auto w-full'>
          {/* Copy under the logo */}
          <div className='lg:grid lg:grid-cols-[1fr_2fr]'>
            {/* Image hidden on mobile by design */}
            <figure className='hidden lg:grid place-items-center'>
              {/* Outer frame: thick grey border */}
              <div className='grid border-[8px] border-solid border-neutral-500'>
                {/* Black gap */}
                <div className='grid bg-black p-2'>
                  {/* Red background panel */}
                  <div className='grid bg-red-700 p-3'>
                    {/* Rotated photo card */}
                    <div className='grid -rotate-6'>
                      <img
                        src={ImageHero}
                        alt='Mistress Diva portrait'
                        loading='eager'
                        fetchpriority='high'
                        decoding='async'
                        className='block h-auto w-auto max-h-[65vh] max-w-[35rem] object-contain
             border-[6px] border-red-700
             shadow-[0_18px_45px_rgba(0,0,0,0.9),16px_0_24px_rgba(0,0,0,0.75),-16px_0_24px_rgba(0,0,0,0.75)]'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <figcaption className='sr-only'>
                Mistress Diva featured image
              </figcaption>
            </figure>
            <article
              className='grid gap-2 text-[#d9d9d9]'
              aria-label='Introductory statements'
            >
              {/* Mistress Diva Name */}
              <NameHeaderComponent />

              {/* New line directly under the name */}
              <div className='grid gap-y-4'>
                <p className='uppercase tracking-wide text-xs sm:text-sm lg:text-xl'>
                  SUPREME GODDESS OF EROTIC ELEGANCE AND STERN DISCIPLINE
                </p>

                {/* Existing intro quotes */}
                <p className='text-sm md:text-base font-bold'>
                  “Your rightful place is here at My feet, enter My realm and
                  let Me turn your deepest darkest desires into a reality.”
                </p>
                <p className='font-semibold uppercase'>
                  By entering this site you are agreeing to ALL of the
                  following:
                </p>
              </div>
              <ul className='list-disc list-inside grid text-xxs lg:text-xs gap-1 text-left pl-2 lg:pl-12'>
                <li>I am an adult and I am at least 18 years of age.</li>
                <li>
                  I do not find sexual or alternative lifestyle material to be
                  offensive or objectionable.
                </li>
                <li>
                  I have the legal right to possess adult material in my
                  community.
                </li>
                <li>
                  I understand the standards and laws of the community in which
                  I live.
                </li>
                <li>
                  I am solely responsible for my actions and I am not
                  influencing minors.
                </li>
                <li>
                  I will not use this material in violation of the above
                  agreement.
                </li>
                <li>
                  If I am in violation of local or federal laws I am solely
                  responsible.
                </li>
                <li>
                  By entering this site, I will have released the providers,
                  owners and creators of this site from any and all
                  responsibility and liability which might arise from such use.
                </li>
              </ul>
            </article>
          </div>

          {/* Disclaimer + CTAs */}
          <section
            className='grid gap-8 lg:gap-3 w-full'
            aria-labelledby='age-disclaimer-title'
          >
            {/* Actions */}
            <nav className='grid gap-2' aria-label='Primary actions'>
              <div className='grid grid-cols-2 gap-6 px-2 lg:text-3xl'>
                {/* EXIT */}
                <a
                  href='https://google.com'
                  className='grid place-items-center px-6 py-3 
                 bg-gradient-to-b from-neutral-900 to-black 
                 border border-neutral-700 
                 text-red-600 font-bold uppercase tracking-wider rounded-xl
                 shadow-[inset_0_3px_6px_rgba(255,255,255,0.25),0_6px_12px_rgba(0,0,0,0.9),0_2px_4px_rgba(0,0,0,0.4)]
                 hover:from-black hover:to-neutral-900 hover:brightness-110
                 transition-all'
                >
                  Exit
                </a>

                {/* ENTER */}
                <Link
                  to={HOME_PAGE_URL}
                  className='grid place-items-center px-6 py-3 
                 bg-gradient-to-b from-neutral-900 to-black 
                 border border-neutral-700 
                 text-red-600 font-bold uppercase tracking-wider rounded-xl
                 shadow-[inset_0_3px_6px_rgba(255,255,255,0.25),0_6px_12px_rgba(0,0,0,0.9),0_2px_4px_rgba(0,0,0,0.4)]
                 hover:from-black hover:to-neutral-900 hover:brightness-110
                 transition-all'
                  aria-label='Proceed to homepage'
                >
                  Enter
                </Link>
              </div>
            </nav>

            <h2 id='age-disclaimer-title' className='sr-only'>
              Age and content disclaimer
            </h2>

            <div className='grid gap-2 text-xs leading-relaxed text-colour1 dark:text-colour1'>
              <p>
                The pages of this website are designed for{' '}
                <strong>ADULTS only</strong> and may include pictures and
                materials that some viewers may find offensive. If you are under
                the age of 18, if such material offends you, or if it is illegal
                to view such material in your community, please exit the site.
              </p>
              <p>
                The following terms and conditions apply to this site. Use of
                the site will constitute your agreement to the following terms
                and conditions:
              </p>
            </div>
          </section>

          {/* Copyright */}
          <section className='grid text-sm' aria-label='Copyright'>
            <p>
              © {new Date().getFullYear()} {CompanyName}
            </p>
          </section>
        </div>
      </div>
    </header>
  );
}

export default IndexPageMainContainer;
